class Console {

    private _methods: {
        method: string;
        original: any;
        noop: any;
    }[] = [];

    private _enabled: boolean = false;

    constructor() {
        let methods: string[] = [
            "assert",
            "clear",
            "count",
            "countReset",
            "debug",
            "dir",
            "dirxml",
            "error",
            "group",
            "groupCollapsed",
            "groupEnd",
            "info",
            "log",
            "table",
            "time",
            "timeEnd",
            "timeLog",
            "timeStamp",
            "trace",
            "warn"
        ];
        for (let method of methods) {
            if (typeof (window.console as any)[method] === "function") {

                this._methods.push({
                    //@ts-ignore
                    noop: (this as any)[method].bind(this),
                    //@ts-ignore
                    original: window.console[method].bind(window.console),
                    method: method
                });
            }
        }
    }

    public get enabled(): boolean {
        return this._enabled;
    }

    public set enabled(value: boolean) {
        if (this._enabled === value) {
            return;
        }
        this._enabled = value;

        for (let info of this._methods) {
            //@ts-ignore
            this[info.method] = value ? info.original : info.noop;
        }
    }

    public assert(condition?: boolean, ...data: any[]): void { }
    public clear(): void { }
    public count(label?: string): void { }
    public countReset(label?: string): void { }
    public debug(...data: any[]): void { }
    public dir(item?: any, options?: any): void { }
    public dirxml(...data: any[]): void { }
    public error(...data: any[]): void { }
    public group(...data: any[]): void { }
    public groupCollapsed(...data: any[]): void { }
    public groupEnd(): void { }
    public info(...data: any[]): void { }
    public log(...data: any[]): void { }
    public table(tabularData?: any, properties?: string[]): void { }
    public time(label?: string): void { }
    public timeEnd(label?: string): void { }
    public timeLog(label?: string, ...data: any[]): void { }
    public timeStamp(label?: string): void { }
    public trace(...data: any[]): void { }
    public warn(...data: any[]): void { }
}

export const console = new Console();